import { createContext, useContext } from 'react';

import CommonStore from './commonStore';
import DecisionEngineStore from './decisionEngineStore';
import FeatureFlagStore from './featureFlagStore';
import FormStore from './formStore';
import InitializeStore from './initializeStore';
import PartnerStore from './partnerStore';
import SubModuleStore from './subModuleStore';
import UserStore from './userStore';
import UtilityStore from './utilityStore';

export interface IStore {
  commonStore: CommonStore;
  utilityStore: UtilityStore;
  subModuleStore: SubModuleStore;
  initializeStore: InitializeStore;
  partnerStore: PartnerStore;
  userStore: UserStore;
  formStore: FormStore;
  featureFlagStore: FeatureFlagStore;
  decisionEngineStore: DecisionEngineStore;
}

export const store: IStore = {
  commonStore: new CommonStore(),
  utilityStore: new UtilityStore(),
  subModuleStore: new SubModuleStore(),
  initializeStore: new InitializeStore(),
  partnerStore: new PartnerStore(),
  userStore: new UserStore(),
  formStore: new FormStore(),
  featureFlagStore: new FeatureFlagStore(),
  decisionEngineStore: new DecisionEngineStore(),
};

store.partnerStore.initReactions();
export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
